module.exports = __webpack_public_path__ + "img/Free-extra.6e9c1c55.png";